import {
  GET_ALL_PROJECTS_FAIL,
  GET_ALL_PROJECTS_REQUEST,
  GET_ALL_PROJECTS_SUCCESS,
  NEARBY_PROJECTS_FAIL,
  NEARBY_PROJECTS_REQUEST,
  NEARBY_PROJECTS_SUCCESS
} from '../constants/nearbyProjectsConstants';

export const nearbyProjectsReducer = (
  state = { nearbyProjects: [] },
  action
) => {
  switch (action.type) {
    case NEARBY_PROJECTS_REQUEST:
      return { loading: true, nearbyProjects: [] };
    case NEARBY_PROJECTS_SUCCESS:
      return { loading: false, nearbyProjects: action.payload };
    case NEARBY_PROJECTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const getAllProjectsReducer = (state = { allProjects: [] }, action) => {
  switch (action.type) {
    case GET_ALL_PROJECTS_REQUEST:
      return { loading: true, allProjects: [] };
    case GET_ALL_PROJECTS_SUCCESS:
      return { loading: false, allProjects: action.payload };
    case GET_ALL_PROJECTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const addCommentReducer = (state = { addComment: {} }, action) => {
  switch (action.type) {
    case NEARBY_PROJECTS_REQUEST:
      return { loading: true, addComment: {} };
    case NEARBY_PROJECTS_SUCCESS:
      return { loading: false, addComment: action.payload };
    case NEARBY_PROJECTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
